import { render, staticRenderFns } from "./waitScan.vue?vue&type=template&id=1d2a3462&scoped=true"
import script from "./waitScan.vue?vue&type=script&lang=js"
export * from "./waitScan.vue?vue&type=script&lang=js"
import style0 from "./waitScan.vue?vue&type=style&index=0&id=1d2a3462&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2a3462",
  null
  
)

export default component.exports